export interface IRegisterDetails {
  email: string;
  password: string;
  name: string;
  firstname: string;
  langCode: string;
  birthdate: string;
  sex: Sex;
  phone: string;
  phoneIndicator: string;
  street: string;
  number: string;
  city: string;
  postalCode: string;
  country: string;
  nationalNumber: string;
}

export interface ICreatedUserOutput {
  id?: number;
  login?: string;
  langID?: number;
  alreadyExists: boolean;
}

export enum Sex {
  MALE = "MALE",
  FEMALE = "FEMALE",
}
